export default "__VITE_ASSET__DDLp576G__"